import React, { useState } from 'react';
import { StyledFmButton, Trigger } from './FmMenuButton.styles';
import { Box } from '../../../Box/Box';
import { Menu, MenuTrigger } from '../../../Menu/Menu';
import { AngleDown } from './img/AngleDown';

export interface Props extends React.ComponentPropsWithoutRef<'button'> {
  buttonText: string;
  menuAriaLabel: string;
  isPressed?: boolean;
  children?: React.ReactNode;
}

export const FmMenuButton = ({
  isPressed,
  buttonText,
  menuAriaLabel,
  children,
  ...rest
}: Props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <Box display="flex">
      <StyledFmButton isPressed={isPressed} {...rest}>
        {buttonText}
      </StyledFmButton>

      <Menu open={isMenuOpen} onOpenChange={open => setIsMenuOpen(open)}>
        <MenuTrigger>
          <Trigger isPressed={isMenuOpen} aria-label={menuAriaLabel}>
            <AngleDown />
          </Trigger>
        </MenuTrigger>

        {children}
      </Menu>
    </Box>
  );
};
